module.exports = __webpack_public_path__ + "img/12_35.12fa5c28.png";